import { useState, useEffect } from "react";

export default function useImagePreloader(images = []) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const preload = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    };

    Promise.all(images.map(preload))
      .then(() => {
        if (isMounted) setLoading(false);
      })
      .catch((error) => {
        console.error("Error preloading images:", error);
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [images]);

  return loading;
}
